import React, { useEffect, useState } from 'react';
import Loading from '../Loading';
import { ReactComponent as SearchMagnifyIcon } from '../../assets/svg/SearchMagnifyIcon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/svg/DeleteIcon.svg';
import { fileSystemUrl } from '../../server/connections';
import { deletePracticeById, getPractices } from '../../server/server';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../modals/ConfirmationModal';
import { notify } from '../../utils/util';
import BigImageModal from '../modals/BigImageModal';

function PracticesHome() {
	const navigate = useNavigate();
	const [practices, setPractices] = useState([]);
	const [allPractices, setAllPractices] = useState<any>([]);
	const [loading, setLoading] = useState(true);
	const [searchTerm, setSearchTerm] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [practiceForDelete, setPracticeForDelete] = useState('');
	const [imageModalOpen, setImageModalOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');

	useEffect(() => {
		loadPractices();
	}, []);

	useEffect(() => {
		if (allPractices.length !== 0) filterPracticesBySearchTerm(allPractices, searchTerm);
	}, [searchTerm]);

	const loadPractices = async () => {
		console.log('practice');
		const resp = await getPractices();
		if (resp.status === 200) {
			setAllPractices(resp.data);
			setPractices(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const filterPracticesBySearchTerm = (practices = allPractices, text = searchTerm) => {
		setPractices(practices?.filter((e: any) => e?.name?.toLowerCase().includes(text?.toLowerCase()) || e?.description?.toLowerCase().includes(text?.toLowerCase())));
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	const deletePractice = async () => {
		const resp = await deletePracticeById(practiceForDelete);
		if (resp.status === 200) {
			loadPractices();
			notify('The practice has been successfully deleted!');
		} else {
			notify('The practice has not been deleted!');
		}
	};

	const openImageModal = (image: string) => {
		setImageModalOpen(true);
		setSelectedImage(image);
	};

	const closeImageModal = () => {
		setImageModalOpen(false);
		setSelectedImage('');
	};

	const PracticeButton = (practice: any) => {
		return (
			<div
				className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[40px] py-[25px] duration-300 ease-out hover:border-mudPurple'
				onClick={() => {
					navigate(`/practices/${practice?.id}`);
				}}
				key={practice.id}
			>
				{!!practice.image && (
					<div
						className='w-full max-w-[160px] rounded-xl'
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							openImageModal(fileSystemUrl + '/' + practice.image?.url);
						}}
					>
						<img style={{ objectFit: 'contain', width: '100%', minHeight: 120, maxHeight: 120 }} src={fileSystemUrl + '/' + practice.image?.url} alt='' />
					</div>
				)}
				<div className='flex-1'>
					<p className='text-[20px] font-semibold text-primaryViolet'>{practice.name}</p>
					<p className='two-lines-of-text mt-[10px] text-[14px] font-medium text-mudPurple'>{practice.description}</p>
				</div>
				<div className='w-[300px]'>
					<div className='flex flex-row items-center '>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold'>Locale:&nbsp; </p>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold'>{practice?.locale?.name}</p>
					</div>
					{/* <div
						className='bg-white border border-redError p-[10px] rounded-[10px] cursor-pointer text-redError font-bold text-[14px] text-center hover:text-white hover:bg-redError ease-in-out duration-200 transition-all'
						onClick={() => setModalIsOpen(true)}
					>
						Delete practice
					</div> */}
				</div>
				<div className='flex items-center justify-center '>
					<div
						className='rounded-full min-w-10 h-10 hover:bg-greyLight flex items-center justify-center '
						onClick={(e) => {
							e.stopPropagation();
							setPracticeForDelete(practice.id);
							setModalIsOpen(true);
						}}
					>
						<DeleteIcon style={{ color: '#5E639B' }} />
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className='flex h-screen flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full min-h-fit   max-w-[1200px] px-[10px]'>
				<div className='w-full min-h-[calc(100vh-80px)]  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					<div className='mb-[30px] flex flex-row  items-end'>
						<p className='flex-1 text-[40px] leading-[50px] font-bold text-darkViolet'>Practices</p>
						<div
							className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full border border-primaryViolet
							bg-white text-[18px] leading-6  font-semibold text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
							onClick={() => navigate(`/practices/new`)}
						>
							Add new practice
						</div>
					</div>
					<div className='mb-[40px] flex w-full flex-row gap-5'>
						<div className='flex  h-[50px] flex-1 flex-row items-center rounded-full border border-primaryViolet  px-4'>
							<input
								type='text'
								placeholder='Search'
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								className='h-full flex-1 rounded-full  outline-none  text-[18px] leading-6  font-semibold text-primaryViolet placeholder:font-medium placeholder:text-mudPurple'
								autoComplete='off'
							/>
							<SearchMagnifyIcon />
						</div>
					</div>
					{loading && (
						<div className='flex w-full flex-grow items-center justify-center'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}
					{practices.length === 0 && !loading && (
						<div className='flex w-full flex-grow  items-center justify-center'>
							{' '}
							<p className='text-center text-[14px] font-medium leading-5 text-mudPurple'>
								This list is empty right now.
								<br /> Consider adding new courses...
							</p>{' '}
						</div>
					)}
					{practices?.map(PracticeButton)}
				</div>
			</div>
			<ConfirmationModal
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				confirmation={deletePractice}
				message={'Do you want to delete this practice?'}
				subMessage='The practice will be permanently deleted.'
			/>
			<BigImageModal modalIsOpen={imageModalOpen} closeModal={closeImageModal} selectedImage={selectedImage} />
		</div>
	);
}

export default PracticesHome;
